var React = require('react');

function Code (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"XMLID_34_"},[React.createElement("path",{"id":"XMLID_37_","fill":"#12ebae","d":"M-221.7,243.4v-6l21.5-10.1v6.5l-14.2,6.5l14.2,6.7v6.5L-221.7,243.4z","key":0}),React.createElement("path",{"id":"XMLID_35_","fill":"#12ebae","d":"M-162.3,237.3v6l-21.5,10.1v-6.5l14.2-6.7l-14.2-6.5v-6.5L-162.3,237.3z","key":1})]));
}

Code.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"-221.7 227.2 59.4 26.3","enableBackground":"new -221.7 227.2 59.4 26.3","xmlSpace":"preserve"};

module.exports = Code;

Code.default = Code;
